export const affiliatePayout = {
  affiliatePayout: " Affiliate Payout",
  search: "Search",
  advanceFilter: "Advance Filter",
  status: "Status",
  paid: "Paid",
  unpaid: "Unpaid",
  cancel: "Cancel",
  filter: "Filter",
  accountName: "Account Name",
  phoneNumber: "Phone Number",
  amount: "Amount",
  requestedDate: "Requested Date",
  startDate: "Start Date",
  endDate: "End Date",
  approvedBy: "Approved By",
  approve: "Approve",
  approved: "Approved",
  selectStatus: "Select Status",
};
